import { createContext } from "react";

const CardItemsContext = createContext([]);
export default CardItemsContext;
